/** Demo-only: client home shows full dashboard after onboarding is finished. */
const KEY = 'misc_demo_onboarding_complete'

export function isClientOnboardingComplete(): boolean {
  try {
    return localStorage.getItem(KEY) === '1'
  } catch {
    return false
  }
}

export function markClientOnboardingComplete(): void {
  try {
    localStorage.setItem(KEY, '1')
  } catch {
    // ignore private mode / quota
  }
}

export function clearClientOnboardingComplete(): void {
  try {
    localStorage.removeItem(KEY)
  } catch {
    // ignore
  }
}
